import moment from 'moment';
import Form from './../../utils/forms/forms';
import { mapGetters } from 'vuex';
import clientService from './../../services/client';
import appointmentService from './../../services/appointment';
import productService from './../../services/product';

export default {
  data() {
    return {
      form: new Form({
        clientId: {
          type: 'select',
          value: '',
        },
        productId: {
          type: 'select',
          value: '',
        },
        date: {
          type: 'date',
          value: '',
        },
        slot: {
          type: 'select',
          value: '',
        },
        details: {
          type: 'textarea',
          value: '',
        },
      }),
      originalSlot: '',
    };
  },

  props: {
    create: {
      type: Function,
      required: true,
    },

    destroy: {
      type: Function,
      required: false,
    },

    date: {
      type: Object,
      required: true,
    },

    appointment: {
      type: Object,
      required: false,
    },
  },

  computed: {
    ...mapGetters({
      clients: 'allClients',
      products: 'allProducts',
    }),
  },

  watch: {
    clients() {
      this.form.setOptions('clientId', this.clients.map(c => (
        { id: c.id, name: c.name || `${c.firstName} ${c.lastName}` }
      )));
    },

    products() {
      this.form.setOptions('productId', this.products);
    },

    'form.productId': function () {
      if (this.form.productId && this.form.date) {
        this.getSlots(this.form.productId);
      }
    },

    'form.date': function () {
      if (this.form.productId && this.form.date) {
        this.getSlots(this.form.productId);
      }
    },
  },

  methods: {
    getSlots(productId) {
      appointmentService.slots(productId, moment(this.form.date).format('YYYY-MM-DD'))
      .then((r) => {
        if (r.data.exceptions && r.data.exceptions.length) {
          const message = r.data.exceptions[0].message.length ?
          r.data.exceptions[0].message : this.$t('static.appointments.index.noSlots');
          this.$message({
            showClose: true,
            customClass: 'error',
            message,
          });
          return;
        } else if (r.data.slots) {
          this.form.setOptions('slot', r.data.slots.map(s => (
            { id: s, name: s }
          )));
          this.form.slot = this.originalSlot;
          this.form.showField('slot');
          return;
        }

        this.$message({
          showClose: true,
          customClass: 'error',
          message: this.$t('static.appointments.index.noSlots'),
        });
      }).catch(e => console.log(e));
    },

    createAppointment() {
      const data = this.form.data();
      data.orderTypeId = 2;
      data.date = moment(data.date).format('YYYY-MM-DD');
      data.time = data.slot;
      this.form.loading = true;
      this.create(data, this.appointment ? this.appointment.id : undefined)
      .then(() => {
        this.form.loading = false;
        this.$emit('close');
      }).catch((e) => {
        this.form.loading = false;
        this.form.recordErrors(e);
      });
    },

    cancel() {
      this.$emit('close');
    },

    goToOverviewPage() {
      this.$router.push({ name: 'orders.edit', params: { id: this.appointment.id } });
      this.$emit('close');
    },

    destroyAppointment(id) {
      this.destroy(id).then(() => {
        this.$emit('close');
      }).catch(() => {
        this.$message({
          message: this.$t('static.appointments.edit.destroyError'),
          customClass: 'error',
          showClose: true,
        });
      });
    },
  },

  mounted() {
    this.form.date = moment(this.date).toString();
    this.form.hideField('slot');
    Promise.all([
      clientService.all(),
      productService.all(),
    ]).then(() => {
      if (this.appointment) {
        this.originalSlot = this.appointment.time;
        const product = this.products
        .filter(p => p.name === this.appointment.serviceName);
        this.form.assignData(Object.assign({}, this.appointment, {
          productId: product.length ? product[0].id : '',
        }));
      }
    });
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/addAppointment/addAppointment.js